import PropTypes from "prop-types";
import React from "react";
import { Button, Modal } from "react-bootstrap";

const ConfirmRegistrationModal = ({
  close,
  identifier,
  loading,
  register,
  showRegistrationModal,
  user,
}) => {
  const displayName = user?.displayName || "";
  const personnelNumber = user?.personnelNumber || "";

  return (
    <Modal show={showRegistrationModal} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>Registratie</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ padding: 15 }}>
          CI-nummer <code>{identifier}</code> koppelen met medewerker{" "}
          {displayName} ({personnelNumber})?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" disabled={loading} onClick={register}>
          Koppeling registreren
        </Button>
        <Button disabled={loading} onClick={close}>
          Annuleren
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmRegistrationModal.propTypes = {
  close: PropTypes.func.isRequired,
  identifier: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  register: PropTypes.func.isRequired,
  showRegistrationModal: PropTypes.bool,
  user: PropTypes.shape({
    personnelNumber: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    resourceType: PropTypes.string.isRequired,
  }),
};

export default ConfirmRegistrationModal;
